<template>
  <div>
    <div class="pt-3 pb-16 Kanit mx-auto" style="max-width: 500px">
      <v-btn color="primary" @click="$emit('close')" text class="pl-0">
        <v-icon class="mr-2">mdi-chevron-left</v-icon>BACK
      </v-btn>
      <div>
        <v-img
          class="fill-height mx-auto"
          lazy-src="@/assets/whiteimg.jpg"
          width="50%"
          :src="
            'https://drive.google.com/uc?export=view&id=' +
            getIdFromUrl(data.Logo)
          "
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>

      <div class="px-4">
        <div style="font-weight: 600; font-size: 25px">
          {{ data.Position }}
        </div>
        <div style="color: black; font-weight: 500">{{ data.Name }}</div>
        <div
          style="
            color: rgb(34 116 155);
            font-size: 17px;

            font-weight: 600;
          "
        >
          {{ data.Salary }}
        </div>
        <v-divider class="my-4"></v-divider>
        <div style="font-weight: 600; font-size: larger" class="primary--text">
          รายละเอียดงาน
        </div>
        <div style="font-size: 14px; color: grey">
          <span style="white-space: pre-wrap">{{ data.Details }} </span>
        </div>
        <template v-if="data.Qualifications">
          <div style="color: grey" class="mt-2">
            <div>
              <span style="color: black; font-size: 17px">คุณสมบัติ</span>
            </div>
            <span style="white-space: pre-wrap; font-size: 14px">
              {{ data.Qualifications }}
            </span>
          </div>
        </template>
        <template v-if="data.Requirements">
          <div style="color: grey" class="mt-2">
            <div>
              <span style="color: black; font-size: 17px">ความต้องการ</span>
            </div>
            <span style="white-space: pre-wrap; font-size: 14px">
              {{ data.Requirements }}
            </span>
          </div>
        </template>
        <template v-if="data.Benefit">
          <div style="color: grey" class="mt-2">
            <div>
              <span style="color: black; font-size: 17px">สวัสดิการ</span>
            </div>
            <span style="white-space: pre-wrap; font-size: 14px">
              {{ data.Benefit }}
            </span>
          </div>
        </template>
        <template v-if="data.Quantity">
          <div style="color: grey" class="mt-2">
            <div>
              <span style="color: black; font-size: 17px">จำนวนที่รับ</span>
            </div>
            <span style="white-space: pre-wrap; font-size: 14px">
              {{ data.Quantity }}
            </span>
          </div>
        </template>
        <template v-if="data.Profile">
          <v-divider class="my-3"></v-divider>
          <div
            style="font-weight: 600; font-size: larger"
            class="primary--text mt-4"
          >
            เกี่ยวกับเรา
          </div>
          <div style="font-size: 14px; color: grey">
            <span style="white-space: pre-wrap">{{ data.Profile }} </span>
          </div>
        </template>
        <v-divider class="my-3"></v-divider>
        <div
          style="font-weight: 600; font-size: larger"
          class="primary--text mt-4"
        >
          ติดต่อ
        </div>
        <div class="mb-1" style="font-size: 14px; color: grey">
          <span style="white-space: pre-wrap">{{ data.Contact }} </span>
        </div>
        <div
          v-if="data.Apply_email"
          class="mb-1"
          style="font-size: 14px; color: grey"
        >
          <span style="white-space: pre-wrap">{{ data.Apply_email }} </span>
        </div>
        <div
          v-if="data.Website"
          class="mb-2"
          style="font-size: 14px; color: grey"
        >
          <span style="white-space: pre-wrap">{{ data.Website }} </span>
        </div>
        <div style="font-size: 14px; color: grey">
          <span style="white-space: pre-wrap">{{ data.Address }} </span>
        </div>
      </div>
    </div>
    <div
      v-ripple
      @click="$emit('register')"
      class="Kanit myshadow"
      style="
        height: 45px;
        width: 100%;
        position: fixed;
        bottom: 0px;
        left: 0px;
        display: flex;
        background-color: #0c2f53;
        justify-content: center;
        align-items: center;
      "
    >
      <span style="color: white; font-size: 20px"> สมัครงาน </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  mounted() {},
  computed: {},
  methods: {
    getIdFromUrl(url) {
      if (url) {
        return url.match(/[-\w]{25,}/);
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>